// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"171":"e93a5fd3","763":"fa69f950"}[chunkId] + ".chunk.css";
};